// extracted by mini-css-extract-plugin
export default {"app":"_3-NUu"};